import { defineMessages } from 'react-intl';

export default defineMessages({
  authSnackbarInvitationEmail: {
    defaultMessage: 'Invitation email was sent successfully.',
    description: 'Auth snackbar - Invitation email',
    id: 'authSnackbarInvitationEmail',
  },
  AuthSnackbarPasswordReset: {
    defaultMessage:
      'Check your inbox for reset instructions. If not received, verify the email spelling and ensure it is your My2N account address.',
    id: 'authSnackbarPasswordReset',
  },
  authSnackbarTooManyResends: {
    defaultMessage: 'You can resend the invitation once every 15 minutes. Try again later.',
    description: 'Auth error snackbar - Resend email spam',
    id: 'authSnackbarInvitationEmail.error.tooManyResends',
  },
});
